import { createContext } from "react";

const ActionsContext = createContext({});

export default ActionsContext;
